/**
 * @file SkeletonTitleCard.tsx
 * @description Loading skeleton for TitleCard
 *
 * Matches the exact structure and dimensions of TitleCard
 * to prevent layout shifts during loading.
 */

import type { ReactElement } from "react";
export function SkeletonTitleCard(): ReactElement {
  return (
    <div className="flex-shrink-0 self-start w-[calc(100vw-3rem)] sm:w-[400px] snap-center">
      {/* Shadow wrapper matching TitleCard */}
      <div className="shadow-[0_10px_40px_rgba(0,0,0,0.7)]">
        <div className="aspect-[2/3] bg-neutral-900 rounded-lg animate-pulse" />
      </div>
    </div>
  );
}
